module.exports = __webpack_public_path__ + "img/index_homel1.92a2195b.png";